import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { HistoricalRedux } from '../Redux/HistoricalRedux'

const historicalCrudObservable = createCRUDObservable({
  mainRedux: HistoricalRedux,
  reduxPath: 'historical',
  dataHandlers: {
    get: response => response.data.data,
  },
})

export const historicalObservers = Object.assign({}, historicalCrudObservable.observers, {})

export const historicalEpic = combineEpics(
  historicalCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/HistoricalObservable.js